export default __webpack_public_path__ + "static/media/cardActivationhelpHighlight.45785f07.png";